<app-customer-account-dialog id="expiredAlert">
  <div id="content">
    <div class="auth-header">
      <h6 class="custom-model-heading">Expired Attention Items</h6>
      <div class="close-btn">
        <button mat-icon-button mat-dialog-close (click)="closeAlertpopup()">
          <i class="fa-sharp fa-regular fa-xmark-large"></i>
        </button>
      </div>
    </div>
    <!--  error wrapper added as to show edits.
    Please confirm the error copy with the PO -->

    <section class="error-wrapper" *ngIf="rootScope.activeCustTab.viewExpiredAlertData.viewExpiredAlertApiFailure">
      <f-alert variant="error">
        <p>{{apiFailureMsg}}</p>
      </f-alert>
    </section>

    <h4>Date Range</h4>
    <div class="date-filter">
      <div class="date-range-fields">
        <form [formGroup]="customerAlertsService.expiredAlertsDateRangeForm" class="date-range-form">
        <mat-form-field appearance="fill" class="component-box">
          <mat-label>Date From (MMM-DD-YYYY)</mat-label>
          <input matInput (dateChange)="onDateChange($event)" formControlName="start" [min]="minDate" [max]="maxDate" [matDatepicker]="picker1" />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="incorrectDateRange()">
            <i class="fa-solid fa-circle-xmark"></i> Incorrect date range selected.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="component-box">
          <mat-label>Date To (MMM-DD-YYYY)</mat-label>
          <input matInput (dateChange)="onDateChange($event)" formControlName="end" [min]="minDateCheck()" [max]="maxDate" [matDatepicker]="picker2" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <mat-error *ngIf="incorrectDateRange()">
            <i class="fa-solid fa-circle-xmark"></i> Incorrect date range selected.
          </mat-error>
        </mat-form-field>

        <f-button text="Search" title="Search" [disabled]="this.customerAlertsService.expiredAlertsDateRangeForm.invalid" (click)="searchExpiredAlerts()" type="button" variant="progressive"></f-button>
        </form>
      </div>

      
    </div>




  <div class="result-data form-scroll">

      <div class="result-data-left">

        <table mat-table [dataSource]="rootScope.activeCustTab.viewExpiredAlertData.viewExpiredAlertTableData" 
        class="alert-table" aria-label ="View Expired Alert">
          
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="author">
            <th mat-header-cell *matHeaderCellDef> Author </th>
            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="expiration">
            <th mat-header-cell *matHeaderCellDef> Expiration </th>
            <td mat-cell *matCellDef="let element"> {{element.expiration}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr tabindex="0" mat-row (click)="onRowSingleClick(row)" (keydown.enter)="onRowSingleClick(row)" 
          (focus)="rootScope.activeCustTab.viewExpiredAlertData.selectedRow = row" [ngClass]="{ selected: row === rootScope.activeCustTab.viewExpiredAlertData.selectedRow }"*matRowDef="let row; columns: displayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length" *ngIf="noRecord()">
              <div class="center no-result">
                {{noRecordFoundMsg}}
              </div>
        
            </td>
          </tr>
        </table>
      </div>
      <div class="result-data-right">
        <f-data-card class="ih-card-container">
          <div class="flex justify-space-between">
            <h6 class="heading">
              Details
            </h6>
          </div>
            <div *ngIf="!checkSelectedRow()">{{noExpiredAlertSelected}}</div>
          <div *ngIf="checkSelectedRow()" class="container form">
            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Type </span>
                <span class="form-value">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.manualAlertType}} </span>
              </div>
              <div class="col-md-4">
                <span class="form-label">Subtype </span>
                <span class="form-value"> {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.manualAlertSubType}}</span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Author</span>
                <span class="form-value"> {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.authorName}} </span>
              </div>
            </div>


            <div class="section-divider"></div>
            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Created </span>
                <span class="form-value">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.created}} </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Expiration </span>
                <span class="form-value">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.expired}} </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Deadline </span>
                <span class="form-value">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.deadlineData}}</span>
              </div>
            </div>
            <div class="section-divider"></div>
            <div class="row">
              <div class="col-md-12">
                <span class="form-label"> Title </span>
                <span class="form-value">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.headline}} </span>
              </div>

            </div>
            <div class="row">
              <div class="col-md-12 ">
                <span class="form-label"> Details </span>
                <span class="form-value alert-details">  {{rootScope.activeCustTab.viewExpiredAlertData.selectedRowDetailData?.detail}}
                </span>
              </div>
            </div>
          </div>
        </f-data-card>
      </div>
    </div>
  </div>
</app-customer-account-dialog>
